// ChatMessage.js - Optimized message component
import React, { memo } from 'react';

const ChatMessage = memo(({ 
  message, 
  currentUserId, 
  userColor, 
  artistName, 
  onDeleteMessage, 
  onModerationAction 
}) => {
  const {
    id,
    memberstackId,
    displayName,
    message: messageText,
    timestamp,
    isArtist,
    color
  } = message;

  // Check if current user can moderate (artist on their own page)
  const canModerate = () => {
    const memberDataString = localStorage.getItem('_ms-mem');
    const memberData = memberDataString ? JSON.parse(memberDataString) : null;
    
    const currentUserName = (memberData?.customFields?.name || '').toLowerCase().trim();
    const cleanArtistName = artistName.replace('/s/', '').replace('s/', '').toLowerCase().trim();
    
    const isAlphaArtist = memberData?.planConnections?.some(
      plan => plan.planId === 'pln_alphaartist-9s5e06q6' && plan.status === 'ACTIVE'
    );

    const isOwnPage = currentUserName === cleanArtistName;
    
    return isAlphaArtist && isOwnPage;
  };

  const handleModerationClick = (e) => {
    e.stopPropagation();
    onModerationAction(message);
  };

  return (
    <div 
      className="message-wrapper"
      style={{ 
        marginBottom: '1rem',
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: '0.125rem'
      }}
    >
      <div style={{
        display: 'flex',
        position: 'relative'
      }}>
        {/* Time stamp */}
        <div style={{
          width: '35px',
          flexShrink: 0,
          marginRight: '0.125rem'
        }}>
          <span style={{
            fontSize: '0.75rem',
            color: '#6b7280',
          }}>
            {new Date(timestamp).toLocaleTimeString([], { 
              hour: '2-digit', 
              minute: '2-digit',
              hour12: true
            }).replace(/\s[AP]M/i, '')}
          </span>
        </div>

        {/* Message content wrapper */}
        <div style={{
          flex: 1,
          overflowWrap: 'break-word',
          position: 'relative',
          marginRight: '30px',
          paddingRight: '10px'
        }}>
          {/* Username line */}
          <div style={{ 
            display: 'inline',
            color: memberstackId === currentUserId ? userColor : (color || '#e5e7eb')
          }}>
            {isArtist && (
              <div style={{
                position: 'relative',
                display: 'inline-block',
                marginLeft: '-0.25rem',
              }}>
                <span className="artist-emoji" style={{
                  fontSize: '0.875rem'
                }}>
                  🖌️
                </span>
                <div className="artist-tooltip" style={{
                  position: 'absolute',
                  bottom: 'calc(100% + 8px)',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  backgroundColor: 'rgba(17, 24, 39, 0.95)',
                  color: 'white',
                  padding: '5px 10px',
                  borderRadius: '8px',
                  fontSize: '0.875rem',
                  fontWeight: '600',
                  whiteSpace: 'nowrap',
                  pointerEvents: 'none',
                  opacity: 0,
                  transition: 'opacity 0.2s',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                  zIndex: 1000
                }}>
                  SuprArtist
                </div>
              </div>
            )}
            <span style={{ 
              fontSize: '0.875rem',
              fontWeight: 600,
            }}>
              {displayName}
            </span>
            <span style={{ 
              marginLeft: '0.25rem',
              marginRight: '0.5rem',
              color: '#d1d5db'
            }}>:</span>
          </div>

          {/* Message text */}
          <span style={{ 
            color: '#d1d5db'
          }}>
            {messageText}
          </span>

          {/* Delete button - only shown for artist on their page */}
          {canModerate() && (
            <button
              onClick={handleModerationClick}
              style={{
                position: 'absolute',
                right: '-30px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'transparent',
                border: 'none',
                borderRadius: '50%',
                width: '24px',
                height: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                opacity: 0,
                color: '#d1d5db',
                fontSize: '24px',
                fontWeight: 'bold',
                padding: 0,
                zIndex: 999,
                lineHeight: 1,
                userSelect: 'none',
                pointerEvents: 'auto',
                transition: 'opacity 0.2s ease'
              }}
            >
              ×
            </button>
          )}
        </div>
      </div>
    </div>
  );
});

ChatMessage.displayName = 'ChatMessage';

export default ChatMessage; 